import { useInject } from '@actr/di';
import { AuthStore } from '@actr/stores/src/stores/stores/account/auth/auth';
import Header from 'Components/layouts/header';
import { useNeededAuthVtbPage } from 'Hooks/account/use-needed-auth-vtb-page';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import ProjectUtils from 'Root/utils/project';

export type PageHeadProps = NonNullable<unknown>
const PageHead: FC<PageHeadProps> = observer(() => {
  const auth = useInject(AuthStore);
  const getMeServerAction = auth.getServerAction('getMe');

  const isNeededAuthVtbPage = useNeededAuthVtbPage();

  if ((ProjectUtils.isSkb() || isNeededAuthVtbPage) && (!getMeServerAction.isComplete)) {
    return null;
  }

  return (
    <Header />
  );
});

export default PageHead;
